import { defineComponent as _defineComponent } from 'vue'
import { DdPage, Release } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { errorMutationNotification } from "@/utils";
import { customMoment, vueApp } from "@/main";
import { computed, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";
import { useDialogStore } from "@/store/dialogs";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletePageModal',
  props: {
    pageId: null,
    value: { type: Boolean }
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageId: DdPage["id"];
  value: boolean;
};



const { $t } = useTranslation();


// const page = ref<DdPage | null>(null);

const { result, loading, refetch } = useQuery<{ page: DdPage }>(
  queries.pageReleases,
  {
    id: computed(() => props.pageId),
  },
  { fetchPolicy: "no-cache" }
);

const page = computed(() => result.value?.page);

const selectedReleaseDates = ref<Release["releaseDate"][]>([]);



function toggleModal(val: boolean) {
  emit("input", val);
}

async function handleSubmit() {
  if (!page.value) {
    return;
  }
  vueApp.$confirm.require({
    header: 'Delete page?',
    message: "This action cannot be undone.",
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      //callback to execute when user confirms the action
      try {
        await apolloClient.mutate({
          mutation: mutations.deleteDdPage,
          variables: {
            id: props.pageId,
            releaseDates: selectedReleaseDates.value,
          },
        });
        useDialogStore().addDialog({ text: "Page deleted" });
        emit("submit");
        toggleModal(false);
      } catch (err) {
        errorMutationNotification(err);
      }
    },
    reject: () => {
      //callback to execute when user rejects the action
    }
  });


}
function formatDate(dateString: string) {
  return customMoment(dateString).format("ddd, DD MMM YYYY");
}

function resetForm() {
  selectedReleaseDates.value = [];
}

watch(
  () => props.value,
  (val) => {
    if (val) {
      resetForm();
      refetch();
    }
  }
);

return { __sfc: true,props, $t, result, loading, refetch, page, selectedReleaseDates, emit, toggleModal, handleSubmit, formatDate, resetForm }
}

})